import type { RouteRecordRaw } from 'vue-router'
import {
  BLANK_LAYOUT,
  BUILDING_PAGE,
  EXCEPTION_COMPONENT,
  LOGIN_OUT,
  PAGE_NOT_FOUND_NAME,
  REDIRECT_NAME,
} from '@/router/constant'

export const PAGE_NOT_FOUND_ROUTE: RouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: EXCEPTION_COMPONENT,
  meta: {
    title: 'ErrorPage',
  },
}

export const PAGE_BUILDING: RouteRecordRaw = {
  path: '/building',
  name: 'building',
  component: BUILDING_PAGE,
  meta: {
    title: 'ErrorPage',
  },
}

export const LOGINOUT_PAGE: RouteRecordRaw = {
  path: '/loginout',
  name: 'loginout',
  component: LOGIN_OUT,
  meta: {
    title: 'LoginOut',
  },
}

export const REDIRECT_ROUTE: RouteRecordRaw = {
  path: '/redirect',
  component: BLANK_LAYOUT,
  name: 'RedirectTo',
  meta: {
    title: REDIRECT_NAME,
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/redirect/:path(.*)/:_redirect_type(.*)/:_origin_params(.*)?',
      name: REDIRECT_NAME,
      component: () => import('@/views/sys/redirect/index.vue'),
      meta: {
        title: REDIRECT_NAME,
        hideBreadcrumb: true,
      },
    },
  ],
}
